import { store } from 'vue-infra';
import { appName } from '../../config';

export function $mutate(module, action, payload) {
  const path = getStorePath(module, action);
  store.commit(path, payload);
}

export function $get(module, action) {
  const path = getStorePath(module, action);
  return store.getters[path];
}

export function $dispatch(module, action, payload) {
  const path = getStorePath(module, action);
  return store.dispatch(path, payload);
}

export function getStorePath(module, action) {
  if (!module) {
    return `${appName}/${action}`;
  }
  return `${appName}/${module}/${action}`;
}
